import React, { useState } from 'react';
import './LegalPages.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // TODO: Implement actual form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitted(true);
    }, 1000);
  };

  if (submitted) {
    return (
      <div className="legal-page">
        <div className="legal-container">
          <div className="contact-success">
            <h1>Thank You!</h1>
            <p>Your message has been sent successfully. We'll get back to you within 24 hours.</p>
            <button onClick={() => setSubmitted(false)} className="contact-button">
              Send Another Message
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <div className="legal-container">
        <header className="legal-header">
          <h1>Contact Us</h1>
          <p className="legal-subtitle">We'd love to hear from you</p>
        </header>

        <div className="contact-content">
          <div className="contact-info-grid">
            <div className="contact-method">
              <h3>📧 Email Us</h3>
              <p>james@theinterconnector.com</p>
              <small>We respond within 24 hours</small>
            </div>
            
            <div className="contact-method">
              <h3>💬 Support</h3>
              <p>james@theinterconnector.com</p>
              <small>For technical issues and account help</small>
            </div>

            <div className="contact-method">
              <h3>🏢 Address</h3>
              <p>Various pet sits, Edinburgh and London</p>
              <small>Business inquiries welcome</small>
            </div>

            <div className="contact-method">
              <h3>📱 Social Media</h3>
              <p>Follow us for updates</p>
              <div className="social-links">
                <a href="https://twitter.com/interconnectorapp" target="_blank" rel="noopener noreferrer">Twitter</a>
                <a href="https://instagram.com/interconnectorapp" target="_blank" rel="noopener noreferrer">Instagram</a>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <h2>Send us a message</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a subject</option>
                  <option value="general">General Inquiry</option>
                  <option value="support">Technical Support</option>
                  <option value="feedback">Feedback</option>
                  <option value="partnership">Partnership</option>
                  <option value="press">Press Inquiry</option>
                  <option value="safety">Safety Concern</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="6"
                  placeholder="Tell us how we can help..."
                  required
                ></textarea>
              </div>

              <button 
                type="submit" 
                className="contact-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;